






























// Composition
import { defineComponent } from '@nuxtjs/composition-api'

// Types
import { ElasticFieldsInterface } from '@/types/search/elasticTypes'

// Common
import { decodeHTMLEntities, slugify } from '@/common/utils/characters'
import { CAREERS_URL, BLOG_URL } from '@/common/static/search'

// Composables
import useSearchAnalytics from '@/composables/analytics/useSearchAnalytics'
import useSearch from '@/composables/search/useSearch'

// Component
// import PageIconSVG from '@/assets/images/search/page.svg?inline'
// import VideoIconSVG from '@/assets/images/search/video.svg?inline'
// import DiagramIconSVG from '@/assets/images/search/diagram.svg?inline'

export default defineComponent({
  name: 'ContentType',

  // components: {
  //   PageIconSVG,
  //   VideoIconSVG,
  //   DiagramIconSVG,
  // },

  props: {
    fields: {
      required: true,
      type: Object as () => ElasticFieldsInterface,
    },
    id: {
      type: [Number, String],
      required: true,
    },
    score: {
      type: Number,
      required: false,
      default: 0,
    },
  },

  setup() {
    const { trackResourceClick } = useSearchAnalytics()
    const { getSearchResultUrl } = useSearch()

    // const isIconComp = (format: string = '') => {
    //   switch (format) {
    //     case 'Page':
    //       return 'PageIconSVG'
    //     case 'Interactive Diagram':
    //       return 'DiagramIconSVG'
    //     case 'Product Listing':
    //       return 'PageIconSVG'
    //     case 'Video':
    //       return 'VideoIconSVG'
    //   }
    // }

    const stripBrand = (fields: ElasticFieldsInterface) => {
      if (fields.title === undefined) {
        return
      }
      const title = fields?.title?.raw.replace(' | Cell Signaling Technology', '')
      return decodeHTMLEntities(title)
    }

    const getResourceHeading = (fields: ElasticFieldsInterface) => {
      const headings = fields?.headings?.raw

      if (!headings) return

      // Take the second element if we have a BLOG or CAREERS URL
      if (fields.url?.raw.includes(BLOG_URL)) {
        return decodeHTMLEntities(headings[1])
      }

      return decodeHTMLEntities(headings[0])
    }

    return {
      decodeHTMLEntities,
      slugify,
      getSearchResultUrl,
      getResourceHeading,
      stripBrand,
      trackResourceClick,
      // isIconComp,
    }
  },
})
